import { ReactNode } from "react"

interface QuickActionCardProps {
  title: string
  text: string
  icon: ReactNode
  onClick: () => void
  /** primary: the filings we offer, secondary: the follow-up procedures */
  tone?: "primary" | "secondary"
}

export default function QuickActionCard({
  title,
  text,
  icon,
  onClick,
  tone = "primary"
}: QuickActionCardProps) {
  return (
    <button
      onClick={onClick}
      className="group flex w-full min-w-0 flex-col gap-3.5 rounded-[14px] border border-appLine bg-white p-5 text-left transition hover:-translate-y-0.5 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dantzOrange"
    >
      <span
        className={`flex h-10 w-10 items-center justify-center rounded-[10px] ${
          tone === "primary"
            ? "bg-dantzBlue text-dantzOrange"
            : "bg-appTile text-dantzBlue"
        }`}
      >
        {icon}
      </span>

      <span className="flex min-w-0 flex-col gap-1">
        <span className="text-[15px] font-semibold text-dantzBlue">{title}</span>
        <span className="text-[13px] text-appMuted">{text}</span>
      </span>
    </button>
  )
}
